import { field, relation, json,text } from '@nozbe/watermelondb/decorators';
import { sanitizeImages } from '../../constants';
import { Model } from '@nozbe/watermelondb';
import { NUDGE_SCHEMA } from '../schema';

export default class Nudge extends Model {
    static table = NUDGE_SCHEMA;

    static associations = {
        user: { type: 'belongs_to', key: 'user' }
    }


    @field('total_step_count') total_step_count;
    @field('completed_count') completed_count;
    @text('name') name;

    @json('completed_steps', sanitizeImages) completed_steps;

    @relation('user', 'user_id') user;
};